import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust path if needed
import Form from 'react-bootstrap/Form';
import { useAuth } from '../context/AuthContext';

const PriorityPopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const socket = getSocket();
    const { userId } = useAuth();
    const [priority, setPriority] = useState(cardDetails?.priority || '');

    const handleSave = () => {
        if (!priority || !cardId || !boardId) return;

        socket.emit('updateCardPriority', {
            card_id: cardId,
            priority,
            board_id: boardId,
            user_id: userId
        });

        onCancel();
    };
 
    return (
        <div className="popup-box popup-priority">
            <div className="popup-header">
                Priority
                <Button icon="pi pi-times" className="p-button-text close-btn" onClick={() => togglePopup("priority")} />
            </div>
            <div className="popup-body">
                <div className="list-EmpLIst pt-2">
                    <Form.Select
                        aria-label="Priority select"
                        className="mb-2 form-select"
                        value={priority}
                        onChange={(e) => setPriority(e.target.value)}
                    >
                        <option value="">Select Priority</option>
                        <option value="Urgent">Urgent</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                    </Form.Select>

                    <Button
                        label="Save"
                        severity="success"
                        className="border-0 py-1 px-3 mt-1 me-2"
                        onClick={handleSave}
                        disabled={!priority}
                    />
                </div>
            </div>
        </div>
    );
};

export default PriorityPopup;